import { Badge, Button, Flex, Icon, Radio, RadioGroup, Spinner, Td, Text, Tr, useToast } from '@chakra-ui/react'
import { format } from 'date-fns'
import { IoIosLink } from 'react-icons/io'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../../../../../services/api'
import { useParams } from 'react-router-dom'
import { FaRegTrashAlt } from 'react-icons/fa'

async function onDeleteLayout({ id_layout, numeroNota, codProd, sequencia }) {
  const response = await api.put('/site/v2/orcamento-crm/remover-layout-pedido', {
    id_layout,
    numero_nota: numeroNota,
    codigo_produto: codProd,
    sequencia,
  })

  return response.data
}

async function handleUpdateAprovado({ id_layout, tipo_aprovacao, codigo_produto, numero_nota, sequencia, link_layout }) {
  const response = await api.put('/site/v2/orcamento-crm/atualiza-status-layout', {
    id_layout,
    tipo_aprovacao,
    codigo_produto,
    numero_nota,
    sequencia,
    link_layout,
  })

  return response.data
}

export function Item({ item, index, codigo_produto, sequencia }) {
  const queryClient = useQueryClient()

  const { numeroProposta: numProposta } = useParams()

  const toast = useToast({
    position: 'top-right',
    isClosable: true,
    duration: 9000,
  })

  const { mutateAsync: deleteItem, isLoading: isLoadingDeleteItem } = useMutation({
    mutationFn: (params) => onDeleteLayout(params),
    onSuccess: (data) => {
      // queryClient.invalidateQueries('infoListLayout')

      queryClient.setQueryData(['infoListLayout', numProposta], (oldData) => {
        const newData = oldData?.filter((layout) => data.id_layout !== layout.id_layout)

        return newData
      })
    },
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (params) => handleUpdateAprovado(params),
    onSuccess: (data) => {
      queryClient.invalidateQueries('infoListLayout')

      queryClient.setQueryData(['items', numProposta], (oldData) => {
        const newData = oldData?.itens?.map((item) => {
          if (item.sequencia === sequencia && item.codigo_produto === codigo_produto) {
            return {
              ...item,
              layout_aprovado: true,
            }
          }

          return item
        })

        return {
          ...oldData,
          itens: newData,
        }
      })

      toast({
        title: 'Layout aprovado com sucesso',
        status: 'success',
      })
    },
    onError: (error) => {},
  })

  async function handleSelect() {
    await mutateAsync({
      id_layout: item.id_layout,
      tipo_aprovacao: 'S',
      codigo_produto: codigo_produto,
      numero_nota: item.numero_nota,
      sequencia,
      link_layout: item.link_layout,
    })
  }

  async function handleDeleteItem() {
    await deleteItem({
      id_layout: item.id_layout,
      numeroNota: item.numero_nota,
      codProd: codigo_produto,
      sequencia,
    })
  }

  return (
    <Tr>
      <Td
        borderRight="1px solid #cfcfcf"
        textAlign="center"
        textTransform="uppercase"
        fontSize="12px"
        bgColor={index % 2 === 0 ? '#f5f5f5' : 'white'}
        py={2}
      >
        <Text as="a" href={item.link_logo} target="_blank" rel="noreferrer">
          <Icon as={IoIosLink} color="#378BBF" fontSize="20px" cursor="pointer" _hover={{ filter: 'brightness(0.9)' }} />
        </Text>
      </Td>
      <Td
        borderRight="1px solid #cfcfcf"
        textAlign="center"
        textTransform="uppercase"
        fontSize="12px"
        py={2}
        bgColor={index % 2 === 0 ? '#f5f5f5' : 'white'}
        position="relative"
      >
        <Flex
          alignItems="center"
          justifyContent="center"
          bgColor="#378BBF"
          w="24px"
          h="24px"
          borderRadius="50%"
          color="white"
          fontSize="12px"
          mx="auto"
          fontWeight="bold"
          as="a"
          href={item.link_layout}
          target="_blank"
          rel="noreferrer"
        >
          {index + 1}
        </Flex>
      </Td>
      <Td
        borderRight="1px solid #cfcfcf"
        textAlign="center"
        textTransform="uppercase"
        fontSize="12px"
        py={2}
        bgColor={index % 2 === 0 ? '#f5f5f5' : 'white'}
        position="relative"
      >
        <Badge fontSize="7px" colorScheme="blue" borderRadius="0" position="absolute" top="-0" left="0">
          {item.vetorizacao && 'Vetorização'}
        </Badge>
        {item.arte_finalista}
      </Td>
      <Td
        borderRight="1px solid #cfcfcf"
        textAlign="center"
        textTransform="uppercase"
        fontSize="12px"
        py={2}
        bgColor={index % 2 === 0 ? '#f5f5f5' : 'white'}
      >
        {item.data_solicitacao ? format(new Date(item.data_solicitacao), 'dd/MM/yyyy / HH:mm:ss') : 'Não tem'}
      </Td>
      <Td
        borderRight="1px solid #cfcfcf"
        textAlign="center"
        textTransform="uppercase"
        fontSize="12px"
        py={2}
        bgColor={index % 2 === 0 ? '#f5f5f5' : 'white'}
      >
        {item.data_encaminhado ? format(new Date(item.data_encaminhado), 'dd/MM/yyyy / HH:mm:ss') : 'Não tem'}
      </Td>
      <Td textAlign="center" textTransform="uppercase" fontSize="12px" py={2} bgColor={index % 2 === 0 ? '#f5f5f5' : 'white'}>
        <RadioGroup>
          {!isLoading ? (
            <Radio colorScheme="blue" size="lg" borderColor="#CFCFCF" isChecked={item.tipo_aprovacao === 'S'} onChange={handleSelect} />
          ) : (
            <Spinner size="sm" color="blue.500" />
          )}
        </RadioGroup>
      </Td>
      <Td textAlign="center" textTransform="uppercase" fontSize="12px" py={2} bgColor={index % 2 === 0 ? '#f5f5f5' : 'white'}>
        <Button
          leftIcon={<Icon as={FaRegTrashAlt} />}
          isLoading={isLoadingDeleteItem}
          onClick={handleDeleteItem}
          colorScheme="red"
          size="sm"
          borderRadius="0"
        >
          <Text fontSize="12px">Excluir</Text>
        </Button>
      </Td>
    </Tr>
  )
}
